import { useTranslations } from 'next-intl';
import { PageHeader, Card } from '@/components/ui';

interface NotAdminStateProps {
  title?: string;
  showTitle?: boolean;
}

export default function NotAdminState({ title, showTitle = false }: NotAdminStateProps) {
  const t = useTranslations('AdminUsers');

  return (
    <div className="space-y-4">
      {showTitle && title && <PageHeader title={title} />}
      <Card>
        <div className="p-8 text-center">
          <div className="bg-primary/10 border-primary/20 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full border">
            <svg
              className="text-primary h-8 w-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>
          <h3 className="text-foreground mb-2 text-lg font-semibold">{t('notAdmin')}</h3>
          <p className="text-foreground/80 text-sm">{t('notAdminHint')}</p>
        </div>
      </Card>
    </div>
  );
}
